import React, {useContext, useEffect, useState} from 'react';
import {Link, useLocation} from 'react-router-dom';

import {ContextAuth} from '../../../common/context/context-auth';

import {Nav} from 'react-bootstrap';

const Navigation = () => {
    const auth = useContext(ContextAuth);
    const pathname = useLocation().pathname;

    // -----------------------------------------------------------------------------------------------------------------

    const [activeKey, setActiveKey] = useState(null);

    useEffect(() => {

        if (pathname === '/more') setActiveKey({id: '5'})
        else setActiveKey(auth.menu.find(({path}) => `${path === '/' ? '' : '/'}${path}` === pathname))

    }, [pathname])

    // -----------------------------------------------------------------------------------------------------------------

    const [navItems, setNavItems] = useState([...auth.menu])

    useEffect(() => {

        const fetchSvg = async () => {

            let navItemsTemp = [...navItems]

            try {

                const svgAll = await Promise.all(navItemsTemp.map(async item => {
                    const svg = await fetch(`/img/menu/${item.icon}.svg?${Date.now()}`);
                    return svg.text();
                }));

                svgAll.map((item, index) => navItemsTemp[index]['svg'] = item)

                setNavItems(navItemsTemp)

            } catch (e) {
                console.log(e)
            }

        };

        fetchSvg()

    }, [])

    // -----------------------------------------------------------------------------------------------------------------

    return (
        <>
            {
                activeKey && (
                    <Nav fill activeKey={activeKey.id}>
                        {
                            navItems.slice(0, 5).map(item => {
                                return (
                                    <Nav.Link as={Link} to={item.path} className="d-flex flex-column align-items-center justify-content-center p-0 text-body" eventKey={item.id} key={item.id} >
                                        <figure dangerouslySetInnerHTML={{__html: item.svg}} className="mb-0 ratio ratio-1x1"/>
                                        <span className="flex-shrink-0 text-truncate fs-11 w-100 ws-n1">{item.title}</span>
                                    </Nav.Link>
                                )
                            })
                        }
                    </Nav>
                )
            }
        </>
    )
}

export default Navigation;